export const calculateEventDuration = (startDate, endDate, startTime, endTime) => {
  if (!startDate || !endDate) return null

  // If no times provided, calculate days only
  if (!startTime || !endTime) {
    const start = new Date(startDate)
    const end = new Date(endDate)
    const diffTime = Math.abs(end - start)
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))

    if (diffDays === 0) return 'Same day event'
    // Add 1 to include both start and end days (e.g., Feb 6-8 is 3 days, not 2)
    const totalDays = diffDays + 1
    if (totalDays === 1) return '1 day'
    return `${totalDays} days`
  }

  // Calculate duration with times
  const startDateTime = new Date(`${startDate}T${startTime}`)
  const endDateTime = new Date(`${endDate}T${endTime}`)

  if (isNaN(startDateTime.getTime()) || isNaN(endDateTime.getTime())) {
    return 'Invalid date/time'
  }

  const diffMs = endDateTime - startDateTime

  if (diffMs <= 0) return 'Invalid duration'

  const diffMinutes = Math.floor(diffMs / (1000 * 60))
  const diffHours = Math.floor(diffMinutes / 60)
  const diffDays = Math.floor(diffHours / 24)

  if (diffDays > 0) {
    const remainingHours = diffHours % 24
    if (remainingHours === 0) {
      return diffDays === 1 ? '1 day' : `${diffDays} days`
    }
    return `${diffDays} day${diffDays > 1 ? 's' : ''}, ${remainingHours} hour${remainingHours > 1 ? 's' : ''}`
  }

  if (diffHours > 0) {
    const remainingMinutes = diffMinutes % 60
    if (remainingMinutes === 0) {
      return diffHours === 1 ? '1 hour' : `${diffHours} hours`
    }
    return `${diffHours} hour${diffHours > 1 ? 's' : ''}, ${remainingMinutes} minute${remainingMinutes > 1 ? 's' : ''}`
  }

  return diffMinutes === 1 ? '1 minute' : `${diffMinutes} minutes`
}

export const formatTimeForDisplay = (time) => {
  if (!time) return ''

  try {
    // Handle various time formats
    const timeObj = new Date(`1970-01-01T${time}`)
    return timeObj.toLocaleTimeString([], {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    })
  } catch {
    return time
  }
}